export default __webpack_public_path__ + "static/media/kili-pack4.812db03f.jpg";